import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
	name: 'safeHtml',
	standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
	constructor(private readonly sanitizer: DomSanitizer) {}

	transform(value: SafeHtml | string | null = ''): SafeHtml {
		if (typeof value === 'string' || value === null) {
			return this.sanitizer.bypassSecurityTrustHtml((value ?? '').toString());
		}
		return value;
	}
}
